// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1qNsB","row":"Node_row__vQGOX","label":"Node_label__2Mluh","footer":"Node_footer__gGxXX"};